import { FileAdapter } from '../platform/types'

export class WebFileAdapter implements FileAdapter {
	// Web version doesn't have native file operations yet
	// Could add download/upload functionality later
}
